import type { HttpClient } from '@/lib/http/client.js'
import type { RevenueDetail, RevenueGranularity, RevenuePage, RevenueSearch } from '@/types/revenue/revenue.type.js'

/** `admin/revenue`, verified against `revenue-admin.controller.ts`. Read-only. */
export interface RevenueService {
  perShop: (query: RevenueSearch) => Promise<RevenuePage>
  forShop: (shopId: string, window: { from?: string; to?: string; granularity?: RevenueGranularity }) => Promise<RevenueDetail>
}

export function createRevenueService(http: HttpClient): RevenueService {
  return {
    perShop: (query) => http.get<RevenuePage>('admin/revenue', { query: { ...query } }),
    forShop: (shopId, window) =>
      http.get<RevenueDetail>(`admin/revenue/${encodeURIComponent(shopId)}`, { query: { ...window } }),
  }
}
